module.exports = __webpack_public_path__ + "static/venue.6e3ce230.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/Viewport/venue.png
// module id = 678
// module chunks = 213534597649335